import { takeLatest, put, call, select } from 'redux-saga/effects';
import { EXPORT_GOODS_REST_TO_EXCEL_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import { setLocalStorage } from "../../helpers/LocalStorage";
import growl from "../../lib/growl/growl";
import * as XLSX from "xlsx";

const request = data => {
    return fetch(`${ url }/export_goods_rest_to_excel`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerExportGoodsRestToExcel(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response?.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }
        else if (response?.error) {
            growl({ type: 'error', message: response.message });
        }
        else if (response?.success) {
            // Проверяем наличие элементов в массиве
            if (response.rest.length) {
                let result = [Object.keys(response.rest[0])];
                response.rest.forEach(elem => {
                    result.push(Object.values(elem));
                });

                const ws = XLSX.utils.aoa_to_sheet(result);

                ws['!cols'] = [
                    { wpx: 200 },
                    { wpx: 100 }
                ];

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, `Остатки товаров на ${ response.date }`);
                XLSX.writeFile(wb, `Остатки товаров на ${ response.date }.xlsx`);
            }
            else {
                growl({ type: 'warning', message: 'Произошла ошибка. Пожалуйста, попробуйте снова.' });
            }
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherExportGoodsRestToExcel() {
    yield takeLatest(EXPORT_GOODS_REST_TO_EXCEL_SAGA, workerExportGoodsRestToExcel);
}